import LabSearchBar from "./LabSearchBar";
import PopularPackagesRail from "./PopularPackagesRail";
import StickyCartBar from "./StickyCartBar";
import { useLabBooking } from "../context/LabBookingContext";

const LabBookingHero = () => {
  const { selectedTests } = useLabBooking();
  const hasSelection = selectedTests.length > 0;

  return (
    <div id="lab-booking" className="mb-8 sm:mb-10">
      <div
        className={`grid grid-cols-12 gap-5 lg:gap-6 ${
          hasSelection ? "items-stretch" : "items-start"
        }`}
      >
        <div className="col-span-12 lg:col-span-8 flex flex-col">
          <span className="inline-flex items-center gap-1.5 text-[11px] font-semibold text-[#13B58E] bg-[#EEF3F2] px-3 py-1.5 rounded-full mb-4">
            <span className="w-1.5 h-1.5 rounded-full bg-[#13B58E]" />
            NABL Accredited Labs · Home Collection Available
          </span>

          <h3 className="text-[24px] sm:text-[28px] font-extrabold text-[#191C1D] mb-1">
            Book Lab Tests at Home
          </h3>
          <p className="text-[13px] text-[#6B7A99] mb-5">
            Trusted by 50,000+ users
          </p>

          <LabSearchBar />

          <StickyCartBar className="mt-auto" />
        </div>

        <div className="col-span-12 lg:col-span-4">
          <PopularPackagesRail />
        </div>
      </div>
    </div>
  );
};

export default LabBookingHero;
